import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
/* eslint-disable quotes */
import { createTheme, alpha, styled } from '@mui/material/styles';
import { EmbersLabeledBox } from '../labeledBox/labeledBox';
import { ROOT_PREFIX as LABELED_BOX_ROOT_PREFIX, LABEL_FOCUS_VISIBLE_CLASS } from '../labeledBox/labeledBoxStyles';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT, PROMETHEAN_MID_PURPLE, PROMETHEAN_BLUE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
import { prometheanFont } from '../styles/font/font';
export var ROOT_PREFIX = 'EmbersCheckbox';
export var NO_LABEL_CLASS = 'EmbersCheckbox-noLabel';
export var GROUP_FORM_GROUP = 'EmbersCheckboxGroup';
export var checkedSvgPath = 'M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM15.9419 9.94194C16.186 9.69786 16.186 9.30214 15.9419 9.05806C15.6979 8.81398 15.3021 8.81398 15.0581 9.05806L10.5 13.6161L8.94194 12.0581C8.69786 11.814 8.30214 11.814 8.05806 12.0581C7.81398 12.3021 7.81398 12.6979 8.05806 12.9419L10.0581 14.9419C10.3021 15.186 10.6979 15.186 10.9419 14.9419L15.9419 9.94194Z';
export var uncheckedSvgPath = 'M19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z';
var checkedSvg = {
  d: "path('".concat(checkedSvgPath, "')"),
  fillRule: 'evenodd',
  clipRule: 'evenodd'
};
var uncheckedSvg = {
  d: "path('".concat(uncheckedSvgPath, "')"),
  fillRule: 'evenodd',
  clipRule: 'evenodd'
};
var indeterminateSvgPath = {
  d: "path('M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM7.5 12.75L16.5 12.75C16.9142 12.75 17.25 12.4142 17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25L7.5 11.25C7.08579 11.25 6.75 11.5858 6.75 12C6.75 12.4142 7.08579 12.75 7.5 12.75Z')",
  fillRule: 'evenodd',
  clipRule: 'evenodd'
};
export var StyledEmbersLabeledBox = styled(EmbersLabeledBox)(_defineProperty({
  '&.EmbersCheckbox-wrap-noTopBottomSpacing': {
    marginTop: -5,
    marginBottom: -5
  }
}, "&:not(.".concat(LABELED_BOX_ROOT_PREFIX, "-labelClickable)"), {
  '>p.MuiTypography-root': {
    padding: 0
  }
}));
export var checkboxTheme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
          maxWidth: 34,
          maxHeight: 34,
          fontFamily: prometheanFont,
          color: PROMETHEAN_TEXT,
          padding: 5,
          '&+.MuiTypography-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            margin: '5px 0 5px 3px',
            padding: '0'
          }),
          svg: {
            path: _objectSpread(_objectSpread({}, uncheckedSvg), {}, {
              fill: PROMETHEAN_TEXT
            })
          },
          '&.MuiCheckbox-indeterminate': {
            color: PROMETHEAN_PURPLE_GRAPE
          }
        }, "&.Mui-focusVisible.".concat(NO_LABEL_CLASS), {
          position: 'relative',
          '::before': {
            content: '" "',
            position: 'absolute',
            display: 'block',
            top: 7,
            right: 7,
            bottom: 7,
            left: 7,
            outline: '2px solid ' + PROMETHEAN_BLUE
          }
        }), "&:not(.".concat(NO_LABEL_CLASS, ")"), {
          // The :active style is only available on touch screens
          '&:active': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
            border: "1px solid ".concat(PROMETHEAN_MID_PURPLE)
          },
          // On devices without touch screen, the :active element is actually the input rather than the wrapper
          '&:has(input:active)': {
            backgroundColor: "".concat(alpha(PROMETHEAN_PURPLE_GRAPE, 0.3), " !important"),
            border: "1px solid ".concat(PROMETHEAN_MID_PURPLE)
          }
        }), '&.Mui-disabled', {
          svg: {
            path: _objectSpread(_objectSpread({}, uncheckedSvg), {}, {
              fill: PROMETHEAN_NEUTRAL_DARK_GREY
            })
          },
          '&.MuiCheckbox-indeterminate': {
            color: PROMETHEAN_NEUTRAL_DARK_GREY
          }
        }), '&.Mui-checked', _defineProperty(_defineProperty({
          color: PROMETHEAN_PURPLE_GRAPE,
          svg: {
            path: _objectSpread(_objectSpread({}, checkedSvg), {}, {
              fill: PROMETHEAN_PURPLE_GRAPE
            })
          }
        }, "&:not(.".concat(NO_LABEL_CLASS, ")"), {
          '&:active': {
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          },
          '&:has(input:active)': {
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        }), '&.Mui-disabled', {
          svg: {
            path: _objectSpread(_objectSpread({}, checkedSvg), {}, {
              fill: PROMETHEAN_NEUTRAL_DARK_GREY
            })
          }
        })), '@media (hover: hover)', {
          '&.MuiCheckbox-root:hover': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
            border: "1px solid ".concat(PROMETHEAN_MID_PURPLE)
          },
          '&.Mui-checked:hover': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        }), '&.EmbersCheckbox-hybridDeviceHover', {
          backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
          border: "1px solid ".concat(PROMETHEAN_MID_PURPLE),
          '&.Mui-checked': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        }),
        indeterminate: _defineProperty(_defineProperty({
          color: PROMETHEAN_PURPLE_GRAPE,
          svg: {
            path: _objectSpread(_objectSpread({}, indeterminateSvgPath), {}, {
              fill: PROMETHEAN_PURPLE_GRAPE
            })
          },
          '@media (hover: hover)': {
            '&.MuiCheckbox-root.MuiCheckbox-indeterminate:hover': {
              backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
              border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
            }
          }
        }, "&:not(.".concat(NO_LABEL_CLASS, ")"), {
          // The :active style is only available on touch screens
          '&:active': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          },
          // On devices without touch screen, the :active element is actually the input rather than the wrapper
          '&:has(input:active)': {
            backgroundColor: "".concat(alpha(PROMETHEAN_PURPLE_GRAPE, 0.3), " !important"),
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        }), '&.Mui-disabled', {
          svg: {
            path: _objectSpread(_objectSpread({}, indeterminateSvgPath), {}, {
              fill: PROMETHEAN_NEUTRAL_DARK_GREY
            })
          }
        })
      }
    }
  }
});
export var checkBoxGroupTheme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          '.EmbersCheckboxGroup-tooltip': {
            marginBottom: 8,
            '.MuiFormLabel-root': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04)
          }
        }
      }
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          '>label.EmbersLabeledBox': _defineProperty({
            '.MuiCheckbox-root': {
              marginTop: -5,
              marginBottom: -5
            },
            '.MuiTypography-root': {
              marginTop: 0,
              marginBottom: 0
            }
          }, "&.".concat(LABEL_FOCUS_VISIBLE_CLASS), {
            '::before': {
              top: 2,
              bottom: 2
            }
          }),
          '&.MuiFormGroup-row': {
            '>.MuiFormControlLabel-root': _defineProperty({
              marginRight: 24,
              '.MuiCheckbox-root': {
                marginLeft: -5
              }
            }, "&.".concat(LABEL_FOCUS_VISIBLE_CLASS), {
              '::before': {
                top: 2,
                bottom: 2,
                left: 2
              }
            })
          },
          '&:not(.MuiFormGroup-row)': {
            '.MuiFormControlLabel-root:not(:first-of-type), .EmbersLabeledBox:not(:first-of-type)': {
              marginTop: 8
            }
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
          marginBottom: 8,
          '&.Mui-focused': {
            color: PROMETHEAN_TEXT
          }
        })
      }
    }
  }
});